<template>
  <div
			class="modal fade bd-example-modal-lg"
			id="calculator"
			tabindex="-1"
			role="dialog"
			aria-labelledby="calculatorLable"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<!-- -----header-------- -->
					
					<div class="modal-header bg-color--dark--2 pr-0">
						<div class="row justify-content-between pr-0 col-12">
							<div class="col-10" v-if="!title">
								<h5 class="modal-title text-white mr-auto" id="calculatorLable">
									ماشین حساب
								</h5>
							</div>
							<div class="col-10" v-else>
								<h5 class="modal-title text-white mr-auto" id="calculatorLable">
									{{title}}
								</h5>
							</div>

							<div class="col-1">
								<button
									type="button"
									class="close pr-0  "
									data-dismiss="modal"
									aria-label="Close"
									style="float:left"
								>
									<span aria-hidden="true" class="text-white">&times;</span>
								</button>
							</div>
						</div>
					</div>
					<!-- --------body---------- -->
					<div class="modal-body bg-color--light--2">
						<form>
							<div class="row justify-content-center justify-content-lg-between">
								<!-- net_amount &  number_of_instalment-->
								<div class="col-9 col-sm-9 col-md-9 col-lg-5">
									<!-- net_amount -->
									<div class="row">
										<div class="col">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.net_amount") }}</label
												>
												<div class="input-group mb-3">
													<vue-numeric
														id="net_amount"
														separator=","
														v-model="net_amount"
														class="form-control"
													></vue-numeric>
													<div class="input-group-prepend rounded-right">
														<label
															class="input-group-text rounded-right"
															for="number_of_instalment"
															>ریال</label
														>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- down_payment -->
									<div class="row">
										<div class="col">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.down_payment") }}</label
												>
												<div class="input-group mb-3">
													<vue-numeric
														id="down_payment"
														separator=","
														v-model="downpayment"
														class="form-control"
													></vue-numeric>
													<div class="input-group-prepend rounded-right">
														<label
															class="input-group-text rounded-right"
															for="number_of_instalment"
															>ریال</label
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								
									<!-- number_of_instalment -->
									<div class="row">
										<div class="col">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.number_of_instalment") }}</label
												>
												<div class="input-group mb-3">
													<select
														class="custom-select rounded-left"
														id="number_of_instalment"
														v-model.number="number_of_instalment"
													>
														
														<option value="12" selected>۱۲</option>
														<option value="24">۲۴</option>
													</select>
													<div class="input-group-prepend ">
														<label
															class="input-group-text rounded-right"
															for="number_of_instalment"
															>ماه</label
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							
								<!-- downpayment & total_amount & instalment_amount & insalment_cost -->
								<div
									class="col-sm-9 col-md-12 col-lg-6 text-center "
								>
									<!----------------- downpayment & total_amount-->
									<div class="row justify-content-around ">
										<!-- total_amount -->
										<div class="col5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.total_amount") }}</label
												>
												<br />
												<vue-numeric
													id="total_amount"
													class="readNumber"
													separator=","
													v-model="total_amount"
													read-only
												></vue-numeric>
												<label for="" class="text-black text-center ml-1 readNumber"
													>ریال</label
												>
											</div>
										</div>
									</div>

									<!---------------- instalment_amount & insalment_cost -->
									<div class="row justify-content-around	">
										<!-- instalment_amount -->
										<div class="col">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.instalment_amount") }}</label
												>
												<br />
												<vue-numeric
													id="instalment_amount"
													class="readNumber"
													read-only
													separator=","
													v-model="instalment_amount"
												></vue-numeric>
												<label
													for="instalment_amount"
													class="text-black text-center ml-1 readNumber"
													>ریال</label
												>
											</div>
										</div>
										
									</div>	
<!-- insalment_cost -->
									<div class="row justify-content-around	">
										<!-- instalment_amount -->
										<div class="col">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("contract.insalment_cost") }}</label
												>
												<br />
												<vue-numeric
													id="insalment_cost"
													class="readNumber"
													read-only
													separator=","
													v-model="insalment_cost"
												></vue-numeric>
												<label
													for="insalment_cost"
													class="text-black text-center ml-1 readNumber"
													>ریال</label
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<!-- --------footer-------- -->
					<div class="modal-footer bg-color--dark--2">
						<button
							type="button"
							class="btn btn-bg--primary mr-auto"
							@click.prevent="calculatore"
						>
							محاسبه
						</button>
						<button
							type="button"
							class="btn btn-bg--darkblue"
							data-dismiss="modal"
						>
							بستن
						</button>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
import VueNumeric from "vue-numeric";
export default {
    components:{
        VueNumeric
    },
	props:['title'],
    data()
    {
        return {
            net_amount: 100000000,
			downpayment: 0.25*100000000,
			number_of_instalment: 12,
			total_amount: 0,
			instalment_amount: 0,
			insalment_cost: 0,
        }
    },
    mounted()
    {
        this.calculatore();
    },
	computed:{
		downpayment_rate:function(){
			console.log("down_payment= ",this.downpayment)
			console.log("instalment_amount= ",this.instalment_amount)
			return (this.downpayment/this.net_amount)
			}
	},
    methods: {
        calculatore() {
			console.log("downpayment_rate= ",this.downpayment_rate)
			let data = {
				net_amount: this.net_amount,
				number_of_instalment: this.number_of_instalment,
				downpayment_rate: this.downpayment_rate
			};
			this.$store
				.dispatch("supplierCalculator", data)
				.then((resp) => {
					console.log(resp),
						// (this.downpayment = resp.body.downpayment), //پیش پرداخت
						(this.total_amount = resp.body.loan_face_value), //مبلغ تسهیلات
						(this.instalment_amount = resp.body.instalment_amount),
						(this.insalment_cost =
							resp.body.total_amount_of_instalments + this.downpayment);
				})
				.catch((err) => {
					console.log(err);
				});
		},
    },
}
</script>

<style>

</style>